export class DashboardEventViewer{
    eventviewerskin(){
        return `
            <div class="container-layout full-height">
                <div class="container-column">
                    <div class="container-body">
                        <div class="container-toolbar">
                            <div class="info-bar has-icon">
                                <span class="toolbar-text">Portfolio</span>
                                <div class="bar-row d-flex align-items-center gap-10">
                                    <button><span class="iconify" data-icon="flowbite:download-solid"></span></button>
                                    <button><span class="iconify" data-icon="mingcute:time-line"></span></button>
                                </div>
                            </div>
                            <div class="toolbar-menu">
                                <div class="dropdown" data-dropdown-id="filter-dropdown">
                                    <button class="dropdown-toggle color-primary" aria-haspopup="true" aria-expanded="false">
                                        <span class="iconify" data-icon="line-md:filter-filled"></span>
                                    </button>
                                    <div class="dropdown-menu" role="menu">
                                        <button role="menuitem">Name</button>
                                        <button role="menuitem">Date</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="has-min-width border-table">
                            <thead>
                                <tr>
                                <th>Severity</th>
                                <th>Site</th>
                                <th>Description</th>
                                <th>State</th>
                                <th>Source</th>
                                <th>Start Date</th>
                                <th>Reception Time</th>
                                <th>Alarm Delay</th>
                                <th>Duration</th>
                                <th>Energy Losses</th>
                                <th>Ack. Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-left"><span class="mode-badge mode-maintenance">30</span></td>
                                    <td class="text-left">Nnamdi</td>
                                    <td class="text-left">Inverter 1 Off</td>
                                    <td class="text-left">Active</td>
                                    <td class="text-left">Inverter 1</td>
                                    <td class="text-left">04/17/2024 14:05:36</td>
                                    <td class="text-left">04/17/2024 14:05:36</td>
                                    <td class="text-left">0s</td>
                                    <td class="text-left">00:10:23</td>
                                    <td class="text-left">0.5MWh</td>
                                    <td class="text-left"><span class="mode-badge mode-auto">Acknowledged</span></td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}